<template>
  <van-popup
    v-model="show"
    class="loading-popup"
    :close-on-popstate="true"
    :close-on-click-overlay="false"
    :closeable="false"
  >
    <div class="custom-loading">
      <div class="tips">系统加载中，请稍等!</div>
      <van-loading type="spinner" color="#1989fa" size="44"></van-loading>
    </div>
  </van-popup>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['globalLoading']),
    show: {
      get() {
        return this.globalLoading
      },
      set(val) {
        this.$store.commit('setGlobalLoading', val)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.custom-loading {
  width: 400px;
  height: 400px;
  background: linear-gradient(to bottom, #e8f3ff, #f2f2f2);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 20px;
  box-sizing: border-box;
  .tips {
    margin-bottom: 80px;
    color: #0a0a0a;
    font-size: 34px;
    font-weight: bold;
  }
}
.loading-popup {
  border-radius: 20px;
  background: linear-gradient(to bottom, #f3edd7, #f2f2f2);
}
</style>
